// extracted by mini-css-extract-plugin
export default {"dvrInfo":"Sgtfc","audioCheckbox":"S11jQ"};